import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MenuComponent from "salad/MenuComponent.js";
import MobileHeaderOnly from "components/headers/light.js";
import GrainFooter from "salad/GrainFooter";

export default () => (
    <div style={{ backgroundColor: "#FFFBDC", minHeight: "100vh" }}>
        <MobileHeaderOnly />
        <AnimationRevealPage compact>
            <MenuComponent />
        </AnimationRevealPage>
        <AnimationRevealPage>
            <GrainFooter/>
        </AnimationRevealPage>
    </div>
);
